import * as R from 'ramda';
import { AvailabilityEnum } from '../modules/products/ProductTypes';
import { GetInputLimitParams } from './useProductLock.types';

export const getInputLimit = ({
  isLocked,
  lockValue,
  availability,
  availableAmount,
  isLockEnabled,
}: GetInputLimitParams) => {
  if (!isLockEnabled) {
    return availableAmount || undefined;
  }

  const dontHaveStock = [AvailabilityEnum.EMPTY, AvailabilityEnum.INFINITE_PRE_ORDER].includes(
    availability,
  );

  if (dontHaveStock || R.isNil(availableAmount)) {
    return isLocked ? lockValue : undefined;
  }

  if (availableAmount < lockValue) {
    return availableAmount;
  }

  return (isLocked && lockValue) || availableAmount || undefined;
};
